// extracted by mini-css-extract-plugin
module.exports =  {"licenceBox":"style-module_licenceBox__t5pbgbtRbrWpNohe9_MY","list":"style-module_list__dyrpJHflkUAC0yZs3_1c"};